import { MatSort } from '@angular/material/sort';
import { TylerMatTableDataSource } from './../../../shared-components/angular-material/extended.class';
import { Component, Input, OnInit, ViewChild, OnChanges } from '@angular/core';
import { System } from '../../../shared-components/System';
import { detailExpand } from '../../../shared-components/angular-material/mat-animations';
import { LoginService } from '../../login/login.service';
import { Attachment } from '../../../shared-components/models/attachment.model';
import { LoginSettings } from '../../login/LoginSetting.model';
import { DomSanitizer } from '@angular/platform-browser';
import { Announcement } from '../announcement.model';

@Component({
    selector: 'announcement-table',
    templateUrl: './announcement-table.component.html',
    styleUrls: [
        './announcement-table.component.css'
    ],
    animations: [
        detailExpand
    ]
})
export class AnnouncementTableComponent implements OnInit, OnChanges {

    // Properties
    _tableData = new TylerMatTableDataSource();
    @Input() classAnnouncements = false;
    columnsToDisplay = ['more', 'announcement'];
    stripHTML: (str: string) => string;
    V10: boolean;
    LoginSettings: LoginSettings;
    selectedRow: Announcement;
    _sort: MatSort;

    // Class Functions
    constructor(
        private loginService: LoginService,
        private sanitizer: DomSanitizer
    ) { }

    @Input() set tableData(value: TylerMatTableDataSource) {
        this._tableData = value;
    }

    get tableData(): TylerMatTableDataSource {
        return this._tableData;
    }

    @ViewChild(MatSort, { static: true }) set sort(value: MatSort) {
        this._sort = value;
        this.tableData.sort = value;
    }

    get sort(): MatSort {
        return this._sort;
    }

    // Event Functions
    ngOnInit() {
        // POST: initializes the data
        this.stripHTML = System.stripHTML;
        this.LoginSettings = this.loginService.LoginSettings;
        this.V10 = this.LoginSettings.V10;
        // Setting columns
        if (this.classAnnouncements) {
            this.columnsToDisplay.splice(1, 0, 'new', 'course', 'teacher');
            if (!this.loginService.LoginSettings.V10) {
                this.columnsToDisplay.push('attachments');
            }
        }
    }

    ngOnChanges() {
        // POST: sets the table data to the right sort
        this.tableData.sort = this.sort;
    }

    showAttachment(attachment: Attachment) {
        // PRE: an attachment link is clicked
        // POST: opens the attachment in a new tab
        System.viewFileFromId(attachment.AttachmentId, attachment.AttachmentFileName);
    }

    transform(content) {
        return this.sanitizer.bypassSecurityTrustHtml(content);
    }
    // Methods
}
